import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../../components/Layout/Layout";
import QuickOnlineAccountServices from "../../../services/QuickOnlineAccountServices";
import { HollowDotsSpinner } from "react-epic-spinners";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import fire from "../../../utils/Toastr";

export default function CreateQuickOnlineReferralCode() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    referralCode: "",
    misCode: "",
    emailAddress: "",
    lastName: "",
    firstName: "",
    description: "",
    isActive: true,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const resp = await QuickOnlineAccountServices.createReferralCode(formValues);
      if (resp && resp.status !== false) {
        fire("success", resp.message || "Referral code created successfully");
        navigate("/online/accounts/referral-codes");
      } else {
        fire("error", resp?.message || "Failed to create referral code");
      }
    } catch (error) {
      console.error("Error creating quick online referral code:", error);
      fire("error", "Failed to create referral code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout
      title="Create Quick Online Referral Code"
      pageTag="account"
      current="/online/accounts/referral-codes"
    >
      <React.Fragment>
        <main>
          <div className="max-w-3xl mx-auto">
            <div className="mb-6">
              <Link
                to="/online/accounts/referral-codes"
                className="inline-flex items-center text-sm text-red-600 hover:text-red-500"
              >
                <ArrowLeftIcon className="h-4 w-4 mr-1" />
                Back to Quick Online Referral Codes
              </Link>
            </div>

            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-lg font-medium text-gray-900">
                  Create Quick Online Referral Code
                </h2>
              </div>
              <form onSubmit={handleSubmit} className="px-6 py-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="referralCode"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Referral Code
                    </label>
                    <input
                      type="text"
                      name="referralCode"
                      id="referralCode"
                      required
                      maxLength={20}
                      value={formValues.referralCode}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                      placeholder="e.g., PTB001"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="misCode"
                      className="block text-sm font-medium text-gray-700"
                    >
                      MIS Code
                    </label>
                    <input
                      type="text"
                      name="misCode"
                      id="misCode"
                      required
                      maxLength={20}
                      value={formValues.misCode}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                      placeholder="e.g., MSC1011"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="firstName"
                      className="block text-sm font-medium text-gray-700"
                    >
                      First Name
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      value={formValues.firstName}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="lastName"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      value={formValues.lastName}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label
                      htmlFor="emailAddress"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Email Address
                    </label>
                    <input
                      type="email"
                      name="emailAddress"
                      id="emailAddress"
                      value={formValues.emailAddress}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label
                      htmlFor="description"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Description
                    </label>
                    <textarea
                      name="description"
                      id="description"
                      rows={3}
                      value={formValues.description}
                      onChange={handleChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        name="isActive"
                        checked={formValues.isActive}
                        onChange={handleChange}
                        className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700">Active</span>
                    </label>
                  </div>
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <Link
                    to="/online/accounts/referral-codes"
                    className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    disabled={loading}
                    className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-60"
                  >
                    {loading ? (
                      <HollowDotsSpinner size={12} color="#FFFFFF" className="mr-2" />
                    ) : null}
                    {loading ? "Creating..." : "Create Referral Code"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </React.Fragment>
    </Layout>
  );
}
